import { render, staticRenderFns } from "./md-price.vue?vue&type=template&id=75a3406a"
import script from "./md-price.vue?vue&type=script&lang=js"
export * from "./md-price.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports